import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Fade,
  Paper,
  ClickAwayListener,
  Tooltip,
  Grid,
} from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import { styled, keyframes } from "@mui/system";

// Image imports
import soucient from "../../../../../assest/soucient.png";
import insurelogistImg from "../../../../../assest/insurelogist.png";
import HRMS from "../../../../../assest/hrms.png";
import { decryptData, encryptData } from "./Encripted";
import CryptoJS from "crypto-js";

// App data array
const socialLinks = [
  {
    href: "https://www.eghrms.athithishala.com/authentication",
    img: HRMS,
    alt: "HRMS",
    title: "HRMS",
    color: "#6b009f",
  },
  {
    href:"https://egpolicyreaderdev.athithishala.com/authentication",
    img: soucient,
    alt: "Soucient",
    title: "Soucient",
    color: "#2cc8ff",
  },
  {
    href:"https://eggrouphealthdev.athithishala.com/authentication",
    img: insurelogistImg,
    alt: "Insurelogist",
    title: "Insurelogist",
    color: "#168140",
  },
];


// Background animation
const backgroundAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const AnimatedPopup = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: 70,
  right: 20,
  width: 300,
  height: "auto",
  borderRadius: "20px",
  padding: "20px",
  overflow: "hidden",
  background: "#ced4da",
  paddingBottom: "5%",
  backgroundSize: "400% 400%",
  animation: `${backgroundAnimation} 8s ease infinite`,
  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
  zIndex: 999,
}));

// Entrance animation
const fadeInSlide = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

// Custom styled icon button
const SocialIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "color" && prop !== "delay",
})(({ color, delay }) => ({
  backgroundColor: "#fff",
  width: 50,
  height: 50,
  borderRadius: "50%",
  fontSize: 24,
  boxShadow: "0 3px 4px rgba(0, 0, 0, 0.15)",
  opacity: 0,
  animation: `${fadeInSlide} 0.6s ease forwards`,
  animationDelay: `${delay}s`,
  transition: "transform 0.3s ease, box-shadow 0.3s, border 0.3s",
  border: `2px solid transparent`,
  "&:hover": {
    transform: "scale(1.2)",
    boxShadow: `0 0 0 2px ${color}, 0 0 0 4px #fff`,
    border: `1px solid ${color}`,
    textDecoration: "none",
    color: "inherit",
  },
}));

export default function ZPatternSocialPopup() {
  const [popupOpen, setPopupOpen] = useState(false);
  const [iconsVisible, setIconsVisible] = useState(false);

    const [fullUrl, setFullUrl] = useState("");

  const setCredentials = (email, password, key) => {
    const ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify({ email, password }),
      "1234"
    ).toString();

    return ciphertext;
  };

  useEffect(() => {
    const email = localStorage.getItem("rememberedEmail") || "";
    const password = localStorage.getItem("rememberedPassword") || "";

    const decEMail = decryptData(email);
    const decPasswod = decryptData(password);

    const dec = setCredentials(decEMail, decPasswod);

    const encodedData = encodeURIComponent(dec);

    setFullUrl(`data=${encodedData}`);
  }, []);

  const togglePopup = () => {
    setPopupOpen((prev) => !prev);
  };

  const closePopup = () => {
    setPopupOpen(false);
    setIconsVisible(false);
  };

  useEffect(() => {
    if (popupOpen) {
      const timer = setTimeout(() => setIconsVisible(true), 100);
      return () => clearTimeout(timer);
    } else {
      setIconsVisible(false);
    }
  }, [popupOpen]);

  return (
    <>
      {/* Waffle Button */}
      <Box sx={{ position: "relative", zIndex: 1000 }}>
        <IconButton onClick={togglePopup}>
          <AppsIcon sx={{ fontSize: "32px !important" }} />
        </IconButton>
      </Box>

      {/* Popup */}
      {popupOpen && (
        <ClickAwayListener onClickAway={closePopup}>
          <Fade in={popupOpen}>
            <AnimatedPopup>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mb: 2 }}
              >
                Our APPS
              </Typography>
              <Grid container spacing={2}>
                {socialLinks.map((link, index) => (
                  <Grid
                    item
                    xs={4}
                    key={index}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    {iconsVisible && (
                      <Tooltip title={link.title} arrow>
                        <SocialIconButton
                          href={`${link.href}?${fullUrl}`}
                          component="a"
                          target="_self"
                          rel="noopener noreferrer"
                          delay={0.1 * index}
                          color={link.color}
                        >
                          <img
                            src={link.img}
                            alt={link.alt}
                            style={{
                              width: 35,
                              height: 35,
                              objectFit: "contain",
                            }}
                          />
                        </SocialIconButton>
                      </Tooltip>
                    )}
                  </Grid>
                ))}
              </Grid>
            </AnimatedPopup>
          </Fade>
        </ClickAwayListener>
      )}
    </>
  );
}
